<ng-container *ngIf="waitingForResponse">
  <mapfre-loading></mapfre-loading>
</ng-container>
<mapfre-header></mapfre-header>
<div class="container mapfre-content" [ngClass]="{ 'not-logged-page': !isAcmic }" >
  <mapfre-card additionalClasses="create-password">
    <ng-container
      *ngIf="
        !successChangePassword &&
        !expiredLink &&
        !tooManyAttempts &&
        !waitingForResponse
      "
    >
      <div class="row text-center">
        <div class="col">
          <div class="header-icon full-icon">
            <ng-container *ngIf="isAcmic">
              <img src="./assets/img/images/icon-createpassword-acmic.svg" alt="password icon"/>
            </ng-container>
          </div>
          <ng-container
            *ngIf="whereInTheProcess === 'createnewpassword'; else createNewPwd"
          >
            <h1 class="title-copy margin-bottom mb8">
              {{ "CREATE_YOUR_PASSWORD" | translate }}
            </h1>
          </ng-container>
          <ng-template #createNewPwd>
            <h1 class="title-copy mb-0">
              {{ "CREATE_NEW_PASSWORD" | translate }}
            </h1>
          </ng-template>
        </div>
      </div>
      <app-create-password-form
        *ngIf="isCreateUserInfoExists"
        [inputs]="createNewPassword"
        (confirmationOfPasswordCreation)="checkForConfirmation($event)"
      >
      </app-create-password-form>
    </ng-container>
  
    <ng-container *ngIf="tooManyAttempts">
      <div class="row text-center">
        <div class="col">
          <div class="header-icon">
            <svg-too-many-attempts-svg></svg-too-many-attempts-svg>
          </div>
          <h1 class="title-copy">
            {{ "TOO_MANY_ATTEMPTS_TITLE" | translate }}
          </h1>
        </div>
      </div>
      <app-forgot-password-too-many-attempts></app-forgot-password-too-many-attempts>
    </ng-container>
  </mapfre-card>
</div>
